__turbopack_context__.v({
  "SAverageContainer": "_5k-HsG_SAverageContainer",
  "SAverageText": "_5k-HsG_SAverageText",
  "SHeading": "_5k-HsG_SHeading",
  "SRatingContainer": "_5k-HsG_SRatingContainer",
});
